import { AuthMethods, ConnectionHubErrorTypes, IIntegrationPartner, IpNames, PENDING_CREDENTIAL_CONFIRMATION_IPS } from "../../../interfaces/interfaces";
import styles from "./ConnectionResults.module.scss";
import { BsCheckCircleFill, BsHourglassSplit } from "react-icons/bs";
import { FaCircleExclamation as ExclamationIcon } from "react-icons/fa6";
import { RiErrorWarningFill as ErrorIcon } from "react-icons/ri";
import { ipShortNames, meritoHelpDeskEmail, TextCopy } from "../EmailOtp/emailOtpHelper";
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { useMemo } from "react";

type Props = {
	selectedIp: IIntegrationPartner;
	success: boolean;
	setSuccess: (value: boolean) => void;
	isUpdated: boolean;
	setStep: (value: number) => void;
	errorType: ConnectionHubErrorTypes
}

let texts = {
	errorHeader: `Unable to Connect Your ? Account!`,
	errorPara: `Please try again. If the issue persists, contact Merito.`,
	successHeader: `Account Connected!`,
	successPara: `It may take up to 45 minutes to fetch the data.`,
};

const ConnectionResults = ({ success, selectedIp, setSuccess, isUpdated, setStep, errorType }: Props) => {
	const shortIpName = ipShortNames[selectedIp?.companyName] ?? selectedIp?.companyName;

	console.log("selectedIp", selectedIp);

	const errorDetails = useMemo(() => {
		if (selectedIp?.authMethod == AuthMethods.email_otp) {
			return {
				header: `${shortIpName} Login Failed!`,
				body: <><div className={styles.subText}>
					This may be due to incorrect email forwarding settings.
				</div>
					<div className={styles.listContainer}>
						<div className={styles.listTitle}>Here’s what you can do:</div>
						<ol>
							<li>
								Check if{" "}
								<span>
									<TextCopy text={meritoHelpDeskEmail} />
								</span>{" "}
								is added correctly as a forwarding address.
							</li>
							<li>
								Ensure the filter is set to forward emails from{" "}
								<span>
									<TextCopy text={selectedIp?.noReplyEmail} />
								</span>{" "}
							</li>
							<li>Verify that the rule forwards OTP emails correctly.</li>
						</ol>
					</div>
					<div className={styles.subText}>
						If the issue persists, contact Merito.
					</div></>,
				buttonText: "Try Again"
			}
		} else if (selectedIp?.authMethod == AuthMethods.email_otp_password) {
			if (errorType == ConnectionHubErrorTypes.invalidCredentials) {
				return {
					header: `Incorrect Email or Password!`,
					body: null,
					buttonText: "Retry Login",
					buttonStyles: styles.centerAlign
				}
			} else {
				return {
					header: <>Unable to Connect Your <br />{`${selectedIp?.companyName}`} Account!</>,
					body: <div style={{ textAlign: "center" }} className={styles.subText}>
						This may be due to incorrect email forwarding settings.
					</div>,
					buttonText: "Try Again",
					buttonStyles: styles.centerAlign
				}
			}
		}
	}, [selectedIp?.authMethod, success, errorType]);



	return (
		<>
			{(selectedIp?.authMethod == AuthMethods.email_otp || selectedIp?.authMethod == AuthMethods.email_otp_password) && !success ? (
				<div className={styles.otpResultsRootContainer}>
					<div className={styles.resultsContainer}>
						<div className={styles.topContainer}>
							<div className={styles.iconContainer}>
								<ErrorIcon />
							</div>
							<div className={styles.title}>{errorDetails?.header}</div>
						</div>
						{errorDetails?.body ? <div className={styles.bodyContainer}>
							{errorDetails?.body}
							{/* <div className={styles.subText}>
								This may be due to incorrect email forwarding settings.
							</div>
							<div className={styles.listContainer}>
								<div className={styles.listTitle}>Here’s what you can do:</div>
								<ol>
									<li>
										Check if{" "}
										<span>
											<TextCopy text={meritoHelpDeskEmail} />
										</span>{" "}
										is added correctly as a forwarding address.
									</li>
									<li>
										Ensure the filter is set to forward emails from{" "}
										<span>
											<TextCopy text={selectedIp?.noReplyEmail} />
										</span>{" "}
									</li>
									<li>Verify that the rule forwards OTP emails correctly.</li>
								</ol>
							</div>
							<div className={styles.subText}>
								If the issue persists, contact Merito.
							</div> */}
						</div> : null}
						<div className={`${styles.bottomContainer} ${errorDetails?.buttonStyles}`}>
							<MeritoButton
								type="primary-1"
								size="lg"
								onClick={() => {
									setStep(10);
								}}
								isRounded={true}
								btnText={errorDetails?.buttonText}
							/>
						</div>
					</div>
				</div>
			) : success &&
				PENDING_CREDENTIAL_CONFIRMATION_IPS.has(selectedIp.companyName as IpNames) ? (
				<div className={styles.statusScreen}>
					<div className={`${styles.info} ${styles.pending}`}>
						<BsHourglassSplit />
					</div>
					<h1>Setup Completed!</h1>
					<p>
						It may take us up to 24 hours to validate your credentials.
						<br />
						If it takes longer, contact Merito.
					</p>
					<></>
				</div>
			) : (
				<div className={styles.statusScreen}>
					<div className={`${styles.info} ${success ? styles.success : styles.error}`}>
						{success ? <BsCheckCircleFill /> : <ExclamationIcon />}
					</div>
					<h1>
						{success
							? texts.successHeader
								.replace("?", selectedIp.companyName)
								.replace("connected", isUpdated ? "updated" : "connected")
							: texts.errorHeader.replace("?", selectedIp.companyName)}
					</h1>
					{success ? (
						<p>{texts.successPara.replace("?", selectedIp.companyName)}</p>
					) : (
						<p>{texts.errorPara.replace("?", selectedIp.companyName)}</p>
					)}
					<></>
				</div>
			)}
		</>
	);
};

export default ConnectionResults;
